import moment from 'moment'

import {
  formatCurrency,
  formatDecimal,
  formatPercentage,
  formatPercentageWithoutLimit,
  formatTpStatus,
} from 'utils/masks'
import {
  FORMAT_DATE_TRUNC,
  FORMAT_DATETIME_TRUNC,
  FORMAT_HOUR,
} from 'constants/config'

const YES = '1'

const NO = '0'

const NULL_VALUE = '-'

export default (type, value, translate, headerLabel, numHouses) => {
  switch (type) {
    case 'generalShowZero':
      return renderGeneralShowZeroField(value)

    case 'currency':
      return renderCurrencyField(value, translate)

    case 'currency-alt':
      return renderCurrencyFieldAlt(value, translate)

    case 'currency-null':
      return renderCurrencyFieldNull(value, translate)

    case 'index':
      return renderIndexField(value, translate)

    case 'index-alt':
      return renderIndexFieldAlt(value, translate)

    case 'decimal':
      return renderDecimalField(value, translate, numHouses)

    case 'decimal2':
      return renderDecimalField2(value, translate)

    case 'percentage':
      return renderPercentageField(value)
    
    case 'percentage_without_limit':
      return renderPercentageFieldWithoutLimit(value)
      
    case 'tpStatus':
      return renderTpStatusField(value, translate, headerLabel)

    case 'date':
      return renderDateField(value)

    case 'datetime':
      return renderDatetimeField(value)

    case 'hour':
      return renderHourField(value)

    case 'percentage-decimal':
      return renderPercentageDecimal(value)

    case 'beeping':
      return renderBeepingField(value)

    case 'general':
    default:
      return renderGeneralField(value)
  }
}

const renderBeepingField = (value) => (value ? 'Bipado' : 'Não bipado')

const renderGeneralField = (value) => value || NULL_VALUE

const renderGeneralShowZeroField = (value) =>
  value || value === 0 ? value : NULL_VALUE

const renderCurrencyField = (value, translate) =>
  formatCurrency(value, translate)

const renderPercentageDecimal = (value) =>
  `${parseFloat(value).toFixed(2).replace('.', ',')}%`

const renderCurrencyFieldAlt = (value, translate) =>
  formatCurrency(value, translate).replace(translate('option.currency'), '')

const renderCurrencyFieldNull = (value, translate) =>
  value !== undefined ? renderCurrencyField(value, translate) : NULL_VALUE

const renderIndexField = (value, translate) => {
  if (value !== undefined) {
    return value.toString() === YES ? translate('true') : translate('false')
  }
}

const renderIndexFieldAlt = (value, translate) => {
  switch (value) {
    case YES:
      return translate('true')
    case NO:
      return translate('false')
    default:
      return NULL_VALUE
  }
}

const renderDecimalField = (value, translate, numHouses) => formatDecimal(value, translate, numHouses)

const renderDecimalField2 = (value, translate) =>
  value || value === 0 ? formatDecimal(value, translate) : NULL_VALUE

const renderPercentageField = (value) => formatPercentage(value)

const renderPercentageFieldWithoutLimit = (value) => formatPercentageWithoutLimit(value)

const renderTpStatusField = (value, translate, headerLabel) =>
  formatTpStatus(value, headerLabel, translate)

const renderDateField = (value) => moment(value).format(FORMAT_DATE_TRUNC)

const renderDatetimeField = (value) => {
  if (!value) return NULL_VALUE

  return moment(value).format(FORMAT_DATETIME_TRUNC)
}

const renderHourField = (value) => {
  if (!value) return NULL_VALUE

  return moment(value).format(FORMAT_HOUR)
}
